<div class="container" style="margin-top:110px;">

  <!-- 検索欄より下 -->
  <div class="search-section" *ngIf="searchParams" [ngClass]="{'close-search-section': closeSearch}">
    <app-search-section [searchSide]="'worker'" [searchService]="searchProjectWorkerService" [id]="projectId"
      [searchParams]="searchParams" (searching)="loadingStart()" (searchFinish)="loadingFinish()" [page]="page">
    </app-search-section>
  </div>

  <app-search-section-toggle [(closeStatus)]="closeSearch"></app-search-section-toggle>

  <div class="main-section">
    <div class="row">
      <div class="col-md-6">
        <div class="header">
          案件
        </div>
      </div>
      <div class="col-md-6">
        <div class="header" *ngIf="!(workers.length === 0 && calc_workers.length === 0)">
          人材候補:
          <label><input style="transform: translateY(2px);" type="checkbox" [(ngModel)]="showRecommend"
              (ngModelChange)="changeDisplayOptions('recommend')"> 推奨候補
          </label>&nbsp;<label><input style="transform: translateY(2px);" type="checkbox" [(ngModel)]="showSearch"
              (ngModelChange)="changeDisplayOptions('search')"> 検索結果
          </label>

        </div>
      </div>
    </div>

    <div class="row">
      <!-- ここから下は、案件の詳細 -->
      <div class="col-md-6" style="height:100%;width:100%;padding:0px 15px;">
        <div *ngIf="baseMailLoad">
          <div class="scroll_list scroll_list_area scroll_base_mail">
            <app-card [mailInfo]="project" [mailType]="'project'" [sharedAccountOffers]="sharedAccountOffers"
              [baseKeywords]="getKeysForBaseMail()" [offeredMailIds]="offeredProjectMailIds" [page]="page"
              (deleted)="onDeletedProject()">
            </app-card>
          </div>

          <button class="btn btn-primary-dark border-0 btn-back " type="button" (click)="transitePage('back')">
            <i class="fa fa-chevron-left margin-right-5"></i>前の案件
          </button>

          <button class="btn btn-primary-dark border-0 btn-next " type="button" (click)="transitePage('next')">
            次の案件<i class="fa fa-chevron-right margin-left-5"></i>
          </button>
        </div>

        <!-- ローディングアニメーション -->
        <ng-container *ngIf="!baseMailLoad">
          <div class="loader"></div>
          <div class="text-center">計算中...</div>
        </ng-container>
      </div>

      <!-- ここから下は、マッチング候補の人材 -->
      <div class="col-md-6" style="height:100%;padding:0px 15px;">
        <div *ngIf="alreadyRead; else elseContent">
          <div class="search-results" infiniteScroll [infiniteScrollDistance]="1.5" [infiniteScrollThrottle]="150"
            [infiniteScrollDisabled]="loading || !showSearch" [scrollWindow]="false" (scrolled)="onScroll()">

            <div *ngIf="showRecommend">
              <div style="position: sticky; top: 0; z-index: 100;">
                <app-filter-switch-annotation [show]="availableLength(calc_workers)" [text]="'推奨候補'">
                </app-filter-switch-annotation>
              </div>
              <ng-container *ngFor="let worker of calc_workers; let i = index">
                <ng-container *ngTemplateOutlet="card; context: {'worker': worker, 'project': project, 'i': i}">
                </ng-container>
              </ng-container>
            </div>
            <div *ngIf="showSearch">
              <div style="position: sticky; top: 0; z-index: 100;">
                <app-filter-switch-annotation [show]="availableLength(workers)" [text]="'検索結果'">
                </app-filter-switch-annotation>
              </div>
              <ng-container *ngFor="let worker of workers; let i = index">
                <ng-container
                  *ngTemplateOutlet="card; context: {'worker': worker, 'project': project, 'i': i+calc_workers.length}">
                </ng-container>
              </ng-container>
            </div>

            <div class="more-btn-wrapper">
              <button *ngIf="!loading && !detailPageInfo.infiniteScrollEnd && showSearch"
                class="btn btn-primary-dark border-0 btn-more" type="button" (click)="onScroll()">
                <i class="fa fa-chevron-down margin-right-5"></i>更に検索
              </button>
            </div>

            <ng-container *ngIf="loading">
              <div class="loader"></div>
              <div class="text-center">計算中...</div>
            </ng-container>
            <!-- 検索結果がないときの表示 -->
            <div class="text-center" *ngIf="workers.length == 0 && detailPageInfo.infiniteScrollEnd">
              候補が見つかりませんでした。<br>
              スキル検索でキーワードを指定して検索し直してみてください
            </div>
            <div class="space"></div>
          </div>


        </div>
        <!-- ローディングアニメーション -->
        <ng-template #elseContent>
          <div class=" loader"></div>
          <div class="text-center">計算中...</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>


<ng-template #card let-worker="worker" let-project="project" let-i="i">
  <div class="link_list_hover " [ngClass]="{'card-reject': mailRejectReasons[worker.id]}"
    [class.link_list_hover]="openCard(i) ? null : true" style="width:100%;margin-bottom:10px;"
    (click)="updateClickOpenLog(worker, i)" *ngIf="!worker.is_pair_already_offered"
    [@dislike]="IsDislikePair(worker.ai_mail_id, project.ai_mail_id)"
    (@dislike.done)="dislikeDoneEvent(worker.ai_mail_id, project.ai_mail_id, $event)">
    <app-card [mailInfo]="worker" [pairMail]="project" [mailType]="'worker'" [sharedAccountOffers]="sharedAccountOffers"
      [offeredMailIds]="offeredWorkerMailIds" [rejectReason]="mailRejectReasons[worker.id]" [page]="page"
      [actionLogId]="ActionLogForDetailId" [clickableArea]="mailRejectReasons[worker.id] ? 0:1"
      [displayStatus]="openCard(i) ? 3 : (mailRejectReasons[worker.id] ? 0:1)" [searchParams]="searchParams"
      [baseKeywords]="getKeys(project.keywords)" [stickyHeaderOffset]="'15px'" (deleted)="onDeletedWorker(i)"
      (click_card)="clickCard(i)"></app-card>
  </div>
</ng-template>